const SanityClient = require("@sanity/client");

exports.sanityClient = SanityClient({
  projectId: process.env.GATSBY_SANITY_PROJECT_ID,
  dataset: process.env.GATSBY_SANITY_DATASET,
  token: process.env.GATSBY_SANITY_STUDIO_TOKEN,
  apiVersion: "2022-08-08",
  useCdn: true,
});
